import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import GetAppIcon from '@mui/icons-material/GetApp';
import {
} from '@mui/material';
import {
} from '@mui/lab';

import {
  FlexGridColumnGroup,
} from '@grapecity/wijmo.react.grid';

// import {
//   getCodeFromGeneralPurposeMap,
// } from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderTextField, renderSelect, renderSelectMultiLine} from '../../../atoms/CustomPart.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
// import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.FILE_MNG_LIST.name, href: ''},
];
const styles = (theme) => ({
  button: {
    margin: '15px 10px 5px 10px',
  },
  wave: {
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  },
  fields: {
    'margin': '0px 10px 15px 10px',
  },
  textFieldDate: {
    margin: '0px 10px 15px 10px',
    width: '42%',
    minWidth: '100px',
  },
  tabPanel: {
    padding: 0,
  },
});

/**
 *  ファイル管理
 * 画面ID:SCZ1011
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const data =[
      {fileName: '屋内線定期調査シート集計表_20240521（統括ＮＷＣ計）', createDate: '2024/05/21', saveLimit: '2025/05/21', jigyosyo: '広島北'},
      {fileName: '屋内線定期調査シート集計表_20240521（ＮＷＣ計）', createDate: '2024/05/21', saveLimit: '2025/05/21', jigyosyo: '広島北'},
      {fileName: '屋内線定期調査シート集計表_20240521（県別計）', createDate: '2024/05/21', saveLimit: '2025/05/21', jigyosyo: '広島北'},
      {fileName: '屋内線定期調査シート集計表_20240521（本店計）', createDate: '2024/05/21', saveLimit: '2025/05/21', jigyosyo: '広島北'},
      {fileName: '屋内線定期調査兼引込線・計器点検シート（４年）_3月_委託１_0001_20240301', createDate: '2024/05/21', saveLimit: '2025/05/21', jigyosyo: '広島北'},
      {fileName: '屋内線定期調査兼引込線・計器点検シート（毎年）_3月_委託１_0001_20240301', createDate: '2024/05/21', saveLimit: '2025/05/21', jigyosyo: '広島北'},
      {fileName: '屋内線定期調査兼引込線・計器点検シート（４年）_5月_委託１_0001_20240501', createDate: '2024/05/21', saveLimit: '2025/05/21', jigyosyo: '広島北'},
      {fileName: '屋内線定期調査兼引込線・計器点検シート（毎年）_5月_委託１_0001_20240501', createDate: '2024/05/21', saveLimit: '2025/05/21', jigyosyo: '広島北'},
      {fileName: '区画番号異動リスト_20240301', createDate: '2024/05/21', saveLimit: '2025/05/21', jigyosyo: '広島北'},
      {fileName: '次回調査年度不整合リスト_20240301', createDate: '2024/05/21', saveLimit: '2025/05/21', jigyosyo: '広島北'},
    ];

    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    let datas = {userName: ''};
    this.props.doSetInitValues(datas);
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    // try {
    //   const result = await this._searchOrder();
    //   if (!result) {
    //     return;
    //   }
    //   // 検索結果が0件の場合、エラーダイアログ表示
    //   if (!this.props.hasOwnProperty('orderList') ||
    //     !this.props.orderList ||
    //     this.props.orderList.length <= 0 ) {
    //     this.props.doShowMessage({
    //       message: 'CE0016',
    //     });
    //   }
    // } catch (error) {
    //   this.props.doShowMessage({
    //     message: 'TKSCS00001S',
    //     action: () => {
    //       this.props.history.push('/login');
    //     },
    //   });
    // }
    // this.gridRef = {}
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'None',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: '300px', maxWidth: '1450px', height: 'auto', width: 'auto'},
      isReadOnly: true,
      isDisplayCount: true,
      checkedFunction: this.checkStateUpdate,
    };

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        <FlexGridColumnGroup binding="jigyosyo" header="旧NW事業所" dataType="String" width={110}/>
        <FlexGridColumnGroup
          binding="fileName"
          header="ファイル名"
          cellTemplate={CellMaker.makeLink({
            click: (e, ctx) => {
              this.doEditLink();
            },
          })}
          dataType="String"
          width={550}/>
        <FlexGridColumnGroup binding="createDate" header="作成日" dataType="String" width={110}/>
        <FlexGridColumnGroup binding="saveLimit" header="保管期限" dataType="String" width={110}/>

      </CustomFlexGrid>
    );
  }

  /**
   * 一覧リンククリック時
   *
   */
  doEditLink = async () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['帳票ダウンロード'],
      },
    });
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    const {
      handleSubmit,
    } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="CSVoutput" item>
          <PositiveButton
            id="CSVoutput"
            onClick={handleSubmit(this.CSVoutput)}
            variant="contained"
            startIcon={<GetAppIcon/>}
          >
            <span>CSV出力</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };

  /**
 * CSV出力クリック時
 */
  CSVoutput = async () => {
    try {
      // let params = {
      //   mod: 'I',
      // };
      // setSessionObject(GMN.INVESTIGATION_YEAR_COMPANY_INFO.id, params);
      // this.props.navigate(GMN_PATH.INVESTIGATION_YEAR_COMPANY_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
      // genericMap,
    } = this.props;

    // フッタボタンを生成
    // const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          //
        >
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          {/* <CustomBreadcrumbs key="keyBFE10112GBreadcrumbs"
            items={this.state.transitionList}/> */}
          <Grid key="keyBFA10111GMsg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Typography variant="h6" gutterBottom>&nbsp;</Typography>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="jigyosyo" item xs={12} sm={2}>
                <Field
                  id="jigyosyo"
                  name="jigyosyo"
                  // variant="standard"
                  component={renderSelect}
                  className={classes.fields}
                  label="NW事業所"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                    shrink: true,
                  }}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  <MenuItem value={5160}>{'広島北'}</MenuItem>
                  <MenuItem value={6120}>{'山口'}</MenuItem>
                </Field>
              </Grid>
              <Grid key="jigyosyoOld" item xs={12} sm={2}>
                <Field
                  id="jigyosyoOld"
                  name="jigyosyoOld"
                  // variant="standard"
                  component={renderSelect}
                  className={classes.fields}
                  label="旧NW事業所"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                    shrink: true,
                  }}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  <MenuItem value={5160}>{'広島北'}</MenuItem>
                  <MenuItem value={5170}>{'廿日市'}</MenuItem>
                </Field>
              </Grid>
              <Grid key="docTypes" item xs={12} sm={4}>
                <Field
                  id="docTypes"
                  name="docTypes"
                  // variant="standard"
                  component={renderSelectMultiLine}
                  className={classes.fields}
                  label="種別"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                  }}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  <MenuItem value={1}>{'屋内線定期調査シート集計表（ＮＷＣ計）'}</MenuItem>
                  <MenuItem value={2}>{'屋内線定期調査シート集計表（統括ＮＷＣ計）'}</MenuItem>
                  <MenuItem value={3}>{'屋内線定期調査シート集計表（県別計）'}</MenuItem>
                  <MenuItem value={4}>{'屋内線定期調査シート集計表（本店計）'}</MenuItem>
                  <MenuItem value={5}>{'屋内線定期調査兼引込線・計器点検シート（４年）'}</MenuItem>
                  <MenuItem value={6}>{'屋内線定期調査兼引込線・計器点検シート（毎年）'}</MenuItem>
                  <MenuItem value={7}>{'区画番号異動リスト'}</MenuItem>
                  <MenuItem value={8}>{'次回調査年度不整合リスト'}</MenuItem>
                  <MenuItem value={9}>{'お客さま異動ファイル'}</MenuItem>

                </Field>
              </Grid>

            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="contractDateFrom" item xs={12} sm={2}>
                <Field
                  id="contractDateFrom"
                  name="contractDateFrom"
                  component={renderTextField}
                  className={classes.fields}
                  fullWidth
                  label="作成日"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // validate={[
                  //   validateRule.date,
                  //   validateRule.correctFromDate(values ? values['contractDateTo'] : null),
                  // ]}
                />
              </Grid>
              <Typography sx={{margin: '18px 0px 20px 25px'}}>
              ～
              </Typography>
              <Grid key="createDateTo" item xs={12} sm={2}>
                <Field
                  id="createDateTo"
                  name="createDateTo"
                  component={renderTextField}
                  className={classes.fields}
                  fullWidth
                  label="作成日"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // validate={[
                  //   validateRule.date,
                  //   validateRule.correctDate(values ? values['contractDateFrom'] : null),
                  // ]}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
              spacing={1}
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  // variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className={classes.button}
                  // size="large"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className={clsx(classes.button)}
                  // size="large"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="key1001List" item xs={12}>
              {this.renderTable()}
            </Grid>
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  genericMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    genericMap: state.common.generalPurposeMap,
    // initialValues: {
    //   dntNo1: '123',
    //   dntNo2: '456',
    //   dntNo3: '789',
    //   hikikomiDnt: '123',
    //   keiyakuNo1: '',
    //   jigyousyo: '456',
    //   states: '2',
    // },
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
